import React from 'react';
import styles from './ManagerWorkplaceItem.module.scss';

interface Props {
	itemName: string;
	hasFolderIcon: boolean;
}

const ManagerWorkplaceItemLabel = ({ itemName, hasFolderIcon }: Props) => {
	return (
		<div className={styles.label}>
			{hasFolderIcon && (
				<img
					src='/dist/icons/folder-open-solid.svg'
					alt='folder'
					className={styles.folderIcon}
					aria-hidden='true'
				/>
			)}
			<div>{itemName}</div>
		</div>
	);
};

export default ManagerWorkplaceItemLabel;
